import { Button } from "@/components/ui/button";
import { Phone, ArrowDown, Zap } from "lucide-react";
import { useState, useEffect } from "react";

export const Hero = () => {
  const [showPhone, setShowPhone] = useState(false);
  const [currentText, setCurrentText] = useState(0);
  const texts = ["Integracyjne", "Korporacyjne", "Jubileuszowe"];

  useEffect(() => {
    const phoneInterval = setInterval(() => setShowPhone(prev => !prev), 3000);
    const textInterval = setInterval(() => setCurrentText(prev => (prev + 1) % texts.length), 4000);
    return () => { clearInterval(phoneInterval); clearInterval(textInterval); };
  }, []);

  const scrollToContactForm = () => {
    document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToAbout = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[hsl(217,91%,97%)]">
      {/* Background image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url(/images/hero-bg.jpg)' }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-[hsl(217,91%,97%)]/90 via-[hsl(217,91%,97%)]/80 to-[hsl(172,66%,95%)]/85" />
      
      {/* Dot pattern */}
      <div className="absolute inset-0 dot-pattern opacity-40" />

      {/* Decorative shapes */}
      <div className="absolute w-[400px] h-[400px] rounded-full bg-primary/5 blur-[80px] -top-32 -right-32" />
      <div className="absolute w-[300px] h-[300px] rounded-full bg-accent/5 blur-[60px] -bottom-24 -left-24" />

      <div className="container relative z-10 text-center px-4">
        <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 text-sm text-primary font-medium">
          <Zap className="w-4 h-4" />
          Atrakcje eventowe dla biznesu
        </div>
        
        <h1 className="font-outfit text-5xl sm:text-6xl md:text-8xl font-extrabold mb-6 tracking-tight">
          <span className="text-foreground">Eventy</span>
          <br />
          <span className="text-gradient animate-gradient-shift bg-[length:200%_200%]">
            {texts[currentText]}
          </span>
        </h1>
        
        <p className="text-lg md:text-xl mb-10 max-w-2xl mx-auto text-muted-foreground leading-relaxed">
          Kompleksowa oprawa artystyczna eventów firmowych.
          Ponad 80 atrakcji, które wyróżnią Twoją imprezę na tle konkurencji.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            size="lg" 
            onClick={scrollToContactForm}
            className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-8 py-6 rounded-xl glow transition-all duration-300 hover:scale-105 w-[260px] flex items-center justify-center gap-2"
          >
            {showPhone ? (
              <>
                <Phone className="w-5 h-5" />
                +48 533 333 993
              </>
            ) : (
              "Zapytaj o atrakcję"
            )}
          </Button>
          <Button 
            size="lg" 
            variant="outline"
            onClick={scrollToAbout}
            className="border-border text-foreground hover:bg-secondary text-lg px-8 py-6 rounded-xl transition-all duration-300"
          >
            Poznaj naszą ofertę
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <button 
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-muted-foreground hover:text-primary transition-colors animate-float"
      >
        <ArrowDown className="w-6 h-6" />
      </button>
    </div>
  );
};
